import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * AnalyticsPixels — loads Google Analytics 4 + Meta (Facebook) Pixel
 * only when the corresponding env vars are configured. Both are optional.
 *
 * Env vars (frontend/.env):
 *   REACT_APP_GA_MEASUREMENT_ID = G-XXXXXXXXXX
 *   REACT_APP_META_PIXEL_ID    = 123456789012345
 *
 * Also tracks route changes as virtual pageviews.
 */
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";
const META_ID = process.env.REACT_APP_META_PIXEL_ID || "";

let _gaInjected = false;
let _metaInjected = false;

function injectGA() {
  if (_gaInjected || !GA_ID) return;
  _gaInjected = true;
  const s1 = document.createElement("script");
  s1.async = true;
  s1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s1);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false }); // manual pageview per route
}

function injectMeta() {
  if (_metaInjected || !META_ID) return;
  _metaInjected = true;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
  window.fbq("init", META_ID);
  /* eslint-enable */
}

export function trackEvent(name, params = {}) {
  try {
    if (GA_ID && window.gtag) window.gtag("event", name, params);
    if (META_ID && window.fbq) window.fbq("trackCustom", name, params);
  } catch {/* no-op */}
}

export function trackPurchase({ amount, currency = "TRY", plan }) {
  try {
    if (GA_ID && window.gtag) {
      window.gtag("event", "purchase", {
        currency, value: amount, items: [{ item_id: plan, item_name: plan }],
      });
    }
    if (META_ID && window.fbq) {
      window.fbq("track", "Purchase", { value: amount, currency, content_ids: [plan], content_type: "product" });
    }
  } catch {/* no-op */}
}

export default function AnalyticsPixels() {
  const location = useLocation();

  // One-time script injection
  useEffect(() => {
    injectGA();
    injectMeta();
  }, []);

  // Route change → pageview
  useEffect(() => {
    const path = location.pathname + location.search;
    try {
      if (GA_ID && window.gtag) {
        window.gtag("event", "page_view", {
          page_path: path, page_location: window.location.href, page_title: document.title,
        });
      }
      if (META_ID && window.fbq) window.fbq("track", "PageView");
    } catch {/* no-op */}
  }, [location]);

  return null;
}
